import {
  FETCH_GMINY_REQUEST,
  FETCH_GMINY_SUCCESS,
  FETCH_GMINY_FAILURE,
  CHANGE_GMINA_WYBIERZ,
} from '../constants';

import fetch from '../core/fetch';

export function pobierzListGmin(prefix) {
  return function (dispatch) {

    dispatch({ type: FETCH_GMINY_REQUEST });
    return fetch(process.env.API_URL + '/powiaty/gminy?powiat=' + prefix, {
      method: 'GET',
    })
    .then(async (response) => {
      if (response.ok) {
        return response.json();
      } else {
        dispatch({ type: FETCH_GMINY_FAILURE });
        throw { error: 'Błąd przy pobieraniu listy gmin', status: response.status, text: await response.text() };
      }
    })
    .then((response) => {
      dispatch({ type: FETCH_GMINY_SUCCESS, payload: response });
      return response;
    })
    .catch(error => {
      console.info(error);
    });
  };
}



// WEBPACK FOOTER //
// src/actions/gminy.js